<template>
  <sidebar-right
    @overlayClicked="outside"
    :class="[
      'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400',
      { open: show }
    ]"
  >
    <div class="bg-white md__card--holder clearfix">
      <div>
        <!-- Card header -->
        <div
          class="card-header d-flex align-items-center"
          :class="{
            'blue-class': $route.name == 'projects',
            'green-class': $route.name == 'tasks.home',
            'green-class': $route.name == 'tasks.quote',
            'yellow-class': $route.name == 'timesheet.home'
          }"
        >
          <h4 class="h3 mb-0">
            <span class="right-bracket">{ </span> Rates
          </h4>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
          <div class="table-responsive p-0 ">
            <table
              class="table align-items-center justify-content-center mb-0 table-custom-one"
            >
              <thead>
                <tr>
                  <th
                    class="text-uppercase text-muted text-xxs font-weight-bold   bg-light "
                  >
                    <div
                      class="d-flex align-items-center lh-1"
                    >
                      Rate({{profile && profile.currency.value}}/HR)
                    </div>
                  </th>

                  <th
                    class="text-uppercase text-muted text-xxs font-weight-bold   bg-light text-center"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center lh-1"
                    >
                      Note
                    </div>
                  </th>

                  <th
                    class="text-uppercase text-muted text-xxs font-weight-bold   bg-light text-center"
                  >
                    <div
                      class="d-flex justify-content-center align-items-center lh-1"
                    >
                      
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody v-if="rateData">
                <tr v-for="(r, ind) in rateData.companyRates || []" :key="ind">
                  <td @click="_onRateSelected(r)" style="cursor:pointer" v-if="model.id != r.id">
                    <span class="font-weight-bold">{{r.rate}}</span>
                  </td>

                  <td class="text-center" @click="_onRateSelected(r)" style="cursor:pointer"  v-if="model.id != r.id">
                    <span class="font-weight-bold">{{r.note}}</span>
                  </td>

                  <td class="text-center" v-if="model.id != r.id">
                    <a v-if="profile && profile.role.name == 'admin' || (project.user_owner &&
        project.user_owner.user.id ==  profile.id) || isApproverForTheProject" href="javascript:void(0)" @click="model=r; showCompanyRateForm=false; editMode=true" style="height:20px;width:20px"  class="pr-2">
                      <i class="fas fa-edit"></i>
                  </a>

                  <a v-if="profile && profile.role.name == 'admin' || (project.user_owner &&
        project.user_owner.user.id == profile.id) || isApproverForTheProject" href="javascript:void(0)" @click="_onDeleteCompanyRate(r.id)" style="height:20px;width:20px"  >
                      <i class="fas fa-trash"></i>
                  </a>
                  </td>

                  <!-- below two td for edit mode -->

                  <td  v-if="model.id == r.id">
                   <input
                      class="form-control form-control--inside-tbl  form-control--placeholder-text-lg"
                      v-model="model.rate"
                       placeholder="Rate"
                    />
                  </td>

                  <td class="text-center" v-if="model.id == r.id">
                   <el-select
                      v-model="model.note"
                      class="radius-0 border-0"
                      style="width: 110px;"
                      size="small"
                      @change="onSaveClicked()"
                      allow-create
                    >
                      <el-option
                        v-for="option in [
                         'Standard',
                         'Strategy',
                         'Expert'
                        ]"
                        :value="option"
                        :label="option"
                        :key="option"
                        class="select-danger"
                      />
                    </el-select> 
                  </td>
                </tr>

                

                <tr v-if="showCompanyRateForm && !editMode">
                  <td>
                   <input
                      class="form-control form-control--inside-tbl  form-control--placeholder-text-lg"
                      v-model="model.rate"
                       placeholder="Rate"
                    />
                  </td>

                  <td class="text-center">
                   <el-select
                      v-model="model.note"
                      class="radius-0 border-0"
                      style="width: 110px;"
                      size="small"
                      @change="onSaveClicked()"
                      allow-create
                    >
                      <el-option
                        v-for="option in [
                         'Standard',
                         'Strategy',
                         'Expert'
                        ]"
                        :value="option"
                        :label="option"
                        :key="option"
                        class="select-danger"
                      />
                    </el-select> 
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr v-if="profile && profile.role.name == 'admin' || (this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id) || isApproverForTheProject">
                  <td colspan="3" class="text-right">
                     <base-button
                      @click="onSaveClicked()"
                      size="sm"
                      type="primary"
                      >{{buttonLabel}}</base-button>

                       <base-button
                       v-if="showCompanyRateForm || editMode"
                      @click="showCompanyRateForm = false; model=null; editMode=false"
                      size="sm"
                      type="danger"
                      >{{'Cancel'}}</base-button>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </sidebar-right>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import SidebarRight from "../layout/SidebarRight.vue";
import swal from "sweetalert2";
export default {
  name: "Rates",
  components: {SidebarRight},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    project: {
      type: Object,
      default: null
    },
    task: {
      type: Object,
      default: null
    },
    value: {
      type: [Object, Array]
    },

    title: String
  },
  data() {
    return {
      showCompanyRateForm: false,
      model: {},
      rateData: null,
      editMode: false
    };
  },

  watch: {

  },

  computed: {
   ...mapState("user", ["profile"]),
    buttonLabel () {
      return this.showCompanyRateForm || this.editMode?"Save":"Add Rate"
    }
  },
  mounted() {
    this.fetchRecords()
  },
  methods: {
    ...mapActions('common', ['fetchRates','createCompanyRate','deleteCompanyRate']),
    async fetchRecords () {
      try{
        let res = await this.fetchRates();
        this.rateData = res
      } catch(err) {
        console.log("Error fetching rates", err)
      }
    },

    async onSaveClicked(v) {
      //this.$emit("input", v);
      this.$emit("saveClicked", v);
      if(this.showCompanyRateForm) {
        //do save
        try {
          let res=null
          if(this.model.id) {
            res = await this.updateCompanyRate(this.model);
          } else {
             res = await this.createCompanyRate(this.model);
          }
          
          
          this.showCompanyRateForm = false
          this.editMode = false
          await this.fetchRecords()
          
        } catch(err) {
          console.log(err)
          this.$snack.success(
            err.response.data.title || "Error saving rate"
          );
        }
        
        //refresh rates
      } else {
        this.showCompanyRateForm = true
      }
      
    },

    _onRateSelected(v) {
      this.$emit("input", v);
      this.$emit("rateSelected", v);
    },

    async _onDeleteCompanyRate(id) {
      //this.$emit("rateRemoveClicked", id);
      swal({
        title: "Are you sure to delete this item?",
        text: `Please click Yes to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          this.deleteRate(id)
        }
      });
    },

    async deleteRate (id) {
      if (id) {
        if (
          this.profile &&
          this.profile.role &&
          this.profile.role.name == "admin"
        ) {
          try {
            let res = await this.deleteCompanyRate(id);
          

            this.$emit("rateDeleted", refresh);
            this.fetchRecords()
         
          } catch (e) {
            console.log("Erro rate delete ", e);
            this.$snack.success("Error occured while deleting rate");
          }
        } else {
          this.$snack.success("You can not delete  rate");
        }
      }
    },

    _onRateRemoved(v) {
      this.$emit("rateRemoveClicked", v);
    },

     outside() {
      this.$emit("outSideClicked");
    },

    isApproverForTheTask(task) {
      return task.approvers.some(c => c.user.id == this.profile.id)
    },

    isApproverForTheProject() {
      return this.project.approvers.some(c => c.user.id == this.profile.id)
    }

    
  }
};
</script>
